module.exports = __webpack_public_path__ + "img/giftbox.bd05a775.png";